//INDIVISUAL USER
export const USER_FETCH_START = "USER_FETCH_START";
export const USER_FETCH_SUCCESS = "USER_FETCH_SUCCESS";
export const USER_FETCH_FAILURE = "USER_FETCH_FAILURE";

//ALL USER
export const ALL_USER_FETCH_START = "ALL_USER_FETCH_START";
export const ALL_USER_FETCH_SUCCESS = "ALL_USER_FETCH_SUCCESS";
export const ALL_USER_FETCH_FINISH = "ALL_USER_FETCH_FINISH";

//POST USER
export const USER_POST_START = "USER_POST_START";
export const USER_POST_SUCCESS = "USER_POST_SUCCESS";
export const USER_POST_FAILURE = "USER_POST_FAILURE";

//GET SPECIFIC USER
export const SPECIFIC_USER_START = "SPECIFIC_USER_START";
export const SPECIFIC_USER_SUCCESS = "SPECIFIC_USER_SUCCESS";
export const SPECIFIC_USER_FAILURE = "SPECIFIC_USER_FAILURE";

export const GET_REPORT_DATA = "GET_REPORT_DATA";

export const USER_REPORT_CLEAR = "USER_REPORT_CLEAR";
